import CssBaseline from "@mui/material/CssBaseline";
import "rsuite/dist/rsuite.min.css";
import "./App.css";
import { MatxTheme, ErrorBoundary } from "./components";
// ALL CONTEXTS
import { AuthProvider } from "./contexts/JWTAuthContext";
import SettingsProvider from "./contexts/SettingsContext";
// ROUTES
import secureRoutes from "./secureRoutes";

export default function App() {
  return (
    <ErrorBoundary>
      <SettingsProvider>
        <AuthProvider>
          <MatxTheme>
            <CssBaseline />
            {secureRoutes()}
          </MatxTheme>
        </AuthProvider>
      </SettingsProvider>
    </ErrorBoundary>
  );
}
